import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Observable, of } from "rxjs";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UIIndividualWarningStates } from "../../constants/ui-individual-warning-states";
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { ButtonComponent } from "@shared/controls/button/button.component";

@Component({
  selector: 'app-update-individual-props-modal',
  standalone: true,
  imports: [
    AgActionIconButtonComponent,
    ButtonComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: 'update-individual-props-modal.component.html',
  styleUrl: 'update-individual-props-modal.component.scss'
})
export class UpdateIndividualPropsModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  toastr = inject(ToastrService);

  @Input() header = '';
  @Input() confirm: Observable<unknown> = of(null);
  @Input() responseError = '';
  @Input() updatePropMessage = '';
  @Input() changeType!: UIIndividualWarningStates;
  @Input() valueBefore = '';
  @Input() valueAfter = '';

  isLoading = signal<boolean>(false);

  ngOnInit(): void {
    this.updatePropMessage = this.getUpdateMessage();
  }

  submit(): void {
    this.isLoading.set(true);
    this.confirm.subscribe({
      next: () => this.activeModal.close(),
      error: (error) => {
        console.warn('[EditStringModalComponent] error: ', error);
        this.toastr.error(this.responseError ?? 'Error happen', 'Error');
      }
    });
  }

  close(): void {
    this.activeModal.dismiss();
  }

  private getUpdateMessage(): string {
    const changeLabel: Record<UIIndividualWarningStates, string> = {
      [UIIndividualWarningStates.Dob]: 'date of birth',
      [UIIndividualWarningStates.BirthPlace]: 'place of birth',
      [UIIndividualWarningStates.Address]: 'address',
    };

    return `Do you want to update the ${ changeLabel[this.changeType] }? You can confirm the change or ignore it.`;
  }
}
